module.exports = __webpack_public_path__ + "static/media/image-4.c0c242ba.jpg";